const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Priceworth Furniture",
    "url": "https://www.priceworth.com.au",
    "logo": "https://www.priceworth.com.au/logo.png",
    "description": "Discover beautiful furniture and homewares at affordable prices. Shop now at Priceworth Furniture.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "AU",
      "addressRegion": "NSW"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+61 425 898 876",
      "contactType": "customer service",
      "email": "priceworth2009@gmail.com"
    },
    "sameAs": [
      "https://www.facebook.com/priceworthfurniture",
      "https://www.instagram.com/priceworthfurniture"
    ],
    "foundingDate": "2009",
    "areaServed": "Australia"
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default OrganizationSchema; 